
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toss",
      function () {
        return require("private-next-pages/toss/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toss"])
      });
    }
  